/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_CreatingInputs */



/**
* | output |
* | --- |
* | "Creating new API Key. Please wait..." |
*
* @param {Options_Api_Keys_CreatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_creating = /** @type {((inputs?: Options_Api_Keys_CreatingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_CreatingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création de la clé API. Veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer API-Schlüssel wird erstellt. Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione di una nuova chiave API. Attendi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание нового ключа API. Пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando nueva clave API. Espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在创建新的 API 密钥。请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいAPIキーを作成しています。お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई API कुंजी बनाई जा रही है। कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando nova chave de API. Aguarde...")
	return /** @type {LocalizedString} */ ("Creating new API Key. Please wait...")
});